var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "new-master" }, [
    _vm.withButton
      ? _c(
          "div",
          {
            staticClass: "button-float",
            class: { active: _vm.opened },
            attrs: { id: "btn-whats-share" },
            on: { click: _vm.toggleFreshDesk }
          },
          [
            _c("img", {
              staticClass: "icon-default donie",
              attrs: {
                src: "/static/whats-share/donie.svg",
                alt: "Suporte",
                title: "Suporte"
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "icon-active",
              attrs: {
                src: "/static/whats-share/close.svg",
                alt: "Fechar",
                title: "Suporte"
              }
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-234849e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-234849e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/WhatsShare/Index.vue
// module id = null
// module chunks = 